<template>
    <div class="relative min-h-screen w-full flex bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="h-full container mx-auto">
            <div class="flex flex-col h-full w-full p-0 sm:p-8">
                <nav class="text-sm text-gray-600 mb-6 flex">
                    <router-link to="/dashboard"
                        class="hover:text-blue-700 transition font-medium">Dashboard</router-link>
                    <span class="mx-1">/</span>
                    <router-link to="/survey-and-feedback-center"
                        class="hover:text-blue-700 transition font-medium">Survey & Feedback Center</router-link>
                    <span class="mx-1">/</span>
                    <span class="text-blue-900 font-semibold">Course Evaluation Survey</span>
                </nav>

                <div class="header-section bg-white shadow-sm rounded-lg p-6 mb-6">
                    <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                        <div>
                            <h1 class="text-2xl font-bold text-gray-900 mb-2">Course Evaluation Survey</h1>
                            <p class="text-gray-600">Collect and review structured course feedback when this module is
                                available.</p>
                        </div>
                    </div>
                </div>

                <coming-soon title="Under development"
                    message="The course evaluation survey experience is being prepared. Please check back later for updates."
                    :show-button="true" button-text="Coming Soon" button-icon="clock" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "course-evaluation-survey-index",
};
</script>
